import { CreditAlertType } from "../model/creditAlertEnums";
import { CreditAlerts } from "../model/creditAlertModel";
import { CreditAlertsError } from "./creditAlerts.reduse";

export const validateCreditAlertForm = (
  data: Partial<CreditAlerts>,
): CreditAlertsError => {
  const errors: CreditAlertsError = {};
  if (!data.alert_type) {
    errors.alert_type = "Alert Type is required";
  }
  if (
    data.threshold_value === undefined ||
    data.threshold_value === null ||
    data.threshold_value < 0
  ) {
    errors.threshold_value =
      "Threshold Value is required and must be a positive number";
  }
  if (
    data.alert_type === CreditAlertType.PERCENTAGE &&
    data.threshold_value !== undefined &&
    data.threshold_value > 100
  ) {
    errors.threshold_value = "Percentage cannot be greater than 100%";
  }
  return errors;
};
